document.addEventListener('DOMContentLoaded', function() {
  const accordionHeaders = document.querySelectorAll('.redesign-accordion-header');
  
  accordionHeaders.forEach(header => {
    header.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
  
      // accordionHeaders.forEach(otherHeader => {
      //   if (otherHeader !== this) {
      //     otherHeader.setAttribute('aria-expanded', 'false');
      //   }
      // });
      
    
      this.setAttribute('aria-expanded', !isExpanded);
    });
  });
});
